import { format } from "date-fns";
import { Instrument } from "./instrument_type";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";

interface Props {
  data: Instrument[];
  onSelect?: (device: Instrument) => void;
  selectedId?: number | null;
}

const ValveControllerTable = ({
  data,
  onSelect,
  selectedId,
}: Props) => {
  const valves = data.filter(
    (d) => d.deviceType === "Valve Controller",
  );

  if (valves.length === 0) return null;

  return (
    <Table
      wrapperClassName="table-responsive rounded border"
      className="table table-hover  table-bordered align-middle text-center mb-0"
    >
      <TableHeader className="bg-light-primary">
        <TableRow>
          <TableHead
            rowSpan={2}
            className="text-center align-middle border-end"
          >
            Instrument
          </TableHead>

          <TableHead
            colSpan={3}
            className="text-center border-start border-end"
          >
            Readings
          </TableHead>

          <TableHead
            colSpan={3}
            className="text-center border-start border-end"
          >
            Details
          </TableHead>

          <TableHead
            colSpan={1}
            className="text-center border-start border-end"
          >
            Status
          </TableHead>

          <TableHead
            rowSpan={2}
            className="text-center align-middle border-start"
          >
            Alert
          </TableHead>

          <TableHead
            rowSpan={2}
            className="text-center align-middle border-start"
          >
            Action
          </TableHead>
        </TableRow>

        <TableRow>
          <TableHead className="text-center border-start">
            Temp (°C)
          </TableHead>

          <TableHead className="text-center">
            Battery (%)
          </TableHead>

          <TableHead className="text-center border-end">
            Door
          </TableHead>

          <TableHead className="text-center">
            Mode
          </TableHead>

          <TableHead className="text-center">
            WM1
          </TableHead>

          <TableHead className="text-center border-end">
            WM2
          </TableHead>

          <TableHead className="text-center border-end">
            On / Off
          </TableHead>
        </TableRow>
      </TableHeader>

      <TableBody>
        {valves.map((device) => {
          const hasAlert =
            !!device.highTemperatureAlarm ||
            !!device.lowBatteryAlarm ||
            !!device.readSwitchHigh;

          return (
            <TableRow
              key={device.id}
              className={`cursor-pointer ${
                selectedId === device.id ? "selected-card" : ""
              }`}
              onClick={() => onSelect?.(device)}
            >
              <TableCell className="text-center text-nowrap border-end">
                <p className="fw-medium mb-0">
                  {device.instrumentName ?? "-"}
                </p>

                <p className="small text-muted mb-0">
                  {device.dateTime
                    ? format(
                        new Date(device.dateTime),
                        "yyyy-MM-dd HH:mm:ss",
                      )
                    : "-"}
                </p>
              </TableCell>

              <TableCell className="text-center border-start">
                {device.temperature ?? "-"}
              </TableCell>

              <TableCell className="text-center">
                {device.battery_Percent ?? 0}%
              </TableCell>

              <TableCell className="text-center border-end">
                {device.doorStatus == 0 ? "Closed" : "Open"}
              </TableCell>

              <TableCell className="text-center">
                {device.auto_Manual == 1 ? "Manual" : "Auto"}
              </TableCell>

              <TableCell className="text-center">
                {device.dI1Counter ?? "-"}
              </TableCell>

              <TableCell className="text-center border-end">
                {device.dI2Counter ?? "-"}
              </TableCell>

              <TableCell className="text-center border-end">
                <span
                  className={
                    device.status == 1
                      ? "text-success fw-bold"
                      : "text-danger fw-bold"
                  }
                >
                  {device.status == 1 ? "ON" : "OFF"}
                </span>
              </TableCell>

              <TableCell className="text-center border-start">
                <span
                  className={`device-alert-indicator ${
                    hasAlert ? "alarm" : "ok"
                  }`}
                />
              </TableCell>

              <TableCell className="text-center border-start">
                <button
                  type="button"
                  className="btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelect?.(device);
                  }}
                >
                  Details
                </button>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default ValveControllerTable;